import type {ReactElement} from 'react';
import React from 'react';
import {Image} from 'react-bootstrap';
import type {ImageBlurBackgroundProps} from './image-blur-background.types';
import styles from './image-blur-background.module.scss';
import {SkeletonBrick} from '@Components/skeleton-brick';

export function ImageBlurBackground({maxWidth, maxHeight, url, containerClass, isLoading = false, imgClass = ''}: ImageBlurBackgroundProps): ReactElement<any> {
  return (
    <div className={`${containerClass} flex-row-align-center justify-content-center _overflow-hidden _position-relative`}>
      {isLoading ? (
        <SkeletonBrick width={maxWidth} height={maxHeight} isPulsating />
      ) : (
        <>
          <Image className={`${imgClass} ${styles.img}`} src={url} style={{maxHeight: `${maxHeight}px`, maxWidth: `${maxWidth}px`}} />
          <div className={styles.backgroundImg} style={{backgroundImage: `url(${url})`}} />
        </>
      )}
    </div>
  );
}
